async function renameFBFile(user, loan, filePath, newName) {
  // for security reasons to compare those value on backend

  // all the query params need to be provided
  const targetUrl = `${process.env.CMS_URL}/loans/renameFBFiles`;
  const token = await user.getIdToken();
  // const sdKey = `SD_${stepID}`;
  // dataTranslation
  const res = await fetch(targetUrl, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({
      id: loan.id,
      filePath: filePath,
      newName: newName,
    }),
  });

  const respJSON = await res.json();

  return respJSON;
}

export default renameFBFile;
